import type { MeetingDetail } from '@fos/shared/contracts/meetings';
import { CALENDAR_MEETING_TEXTS } from '@fos/shared/labels';
import { CalendarSync, Lock } from 'lucide-react';
import { ContextBanner } from '../../../ui/Blocks';
import { Button } from '../../../ui/Button';
import { useMeetingRecordActions } from './MeetingActions';

/**
 * Spotkanie z kalendarza (link iCal, Fala 9): z czyjego kalendarza i kto je widzi. Kalendarz osobisty = prywatne,
 * dopóki właściciel nie udostępni go zespołowi („Udostępnij zespołowi” / „Cofnij udostępnienie” — tylko właściciel,
 * backend i tak to sprawdza). Spotkanie spoza kalendarza — nic.
 */
export function CalendarPrivacyBanner({ meeting, className }: { meeting: MeetingDetail; className?: string }) {
  const actions = useMeetingRecordActions();
  const info = meeting.calendar;
  if (!info) return null;

  const privateMine = info.personal && info.mine && !info.shared;
  const text = !info.personal
    ? CALENDAR_MEETING_TEXTS.company
    : info.mine
      ? info.shared
        ? CALENDAR_MEETING_TEXTS.sharedMine
        : CALENDAR_MEETING_TEXTS.privateMine
      : CALENDAR_MEETING_TEXTS.sharedForeign(info.ownerName);

  return (
    <ContextBanner tone="info" icon={privateMine ? Lock : CalendarSync} className={className}>
      <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1">
        <span>{text}</span>
        {info.canShare && !meeting.archivedAt && (
          <Button variant="ghost" size="s" loading={actions.sharing} onClick={() => actions.toggleShare(meeting)}>
            {info.shared ? CALENDAR_MEETING_TEXTS.unshare : CALENDAR_MEETING_TEXTS.share}
          </Button>
        )}
      </div>
    </ContextBanner>
  );
}
